import { createApp } from 'vue'
import axios from "axios";
import App from './App.vue'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n'
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faVolumeHigh, faVolumeXmark, faExpand, faFilePdf, faPenToSquare, faTrash, faCircleInfo, faPlay, faPause, faSpinner, faCompress, faCircleCheck, faCircleXmark  } from '@fortawesome/free-solid-svg-icons'
library.add(faVolumeHigh, faVolumeXmark, faExpand, faFilePdf, faPenToSquare, faTrash, faCircleInfo,faPlay, faPause, faSpinner, faCompress, faCircleCheck, faCircleXmark)

import ConfirmationService from 'primevue/confirmationservice';

import RadialProgress from "vue3-radial-progress";

import PrimeVue from 'primevue/config';
import Menubar from 'primevue/menubar';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Image from 'primevue/image';
import ToolBar from './components/ToolBar.vue';
import Dropdown from 'primevue/dropdown';
import SelectButton from 'primevue/selectbutton';
import DataTable from 'primevue/datatable';
import Editor from 'primevue/editor';
import FileUpload from 'primevue/fileupload';
import Paginator from 'primevue/paginator';
import Message from 'primevue/message';
import Dialog from 'primevue/dialog';
import Listbox from 'primevue/listbox';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import ProgressSpinner from 'primevue/progressspinner';
import ProgressBar from 'primevue/progressbar';
import Tooltip from 'primevue/tooltip';
import ScrollPanel from 'primevue/scrollpanel';
import Fieldset from 'primevue/fieldset';
import Dock from 'primevue/dock';
import Avatar from 'primevue/avatar';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import SpeedDial from 'primevue/speeddial';
import Chart from 'primevue/chart';
import ConfirmDialog from 'primevue/confirmdialog';
import InputNumber from 'primevue/inputnumber';
import PanelMenu from 'primevue/panelmenu';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Textarea from 'primevue/textarea';
import CascadeSelect from 'primevue/cascadeselect';
import AutoComplete from 'primevue/autocomplete';
import ToggleSwitch from 'primevue/toggleswitch';
import DatePicker from 'primevue/datepicker';

axios.defaults.crossDomain = true;
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}`;
if (localStorage.getItem('accessToken')) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
}

axios.interceptors.response.use(response => {
  return Promise.resolve(response)
}, error => {
 if (error.response.status === 401) {
  store.dispatch('clearToken')
  router.push({ name: 'SignIn' })
 }
 if (error.response.status === 503) {
  router.push({ name: 'Maintenance' })
 }
 return Promise.reject(error)
});

const app = createApp(App)

const messages = {
  th: {
    message: {
      auth:{
        signin: 'เข้าสู่ระบบ',
        signout: 'ออกจากระบบ'
      },
      partner: {
        title: 'พาร์ทเนอร์',
        add:'เพิ่ม',
        list: 'รายชื่อ'
      },
      lesson: {
        title: 'บทเรียน',
        add:'เพิ่ม',
        list: 'รายการ'
      },
      user: {
        title: 'ผู้ใช้งาน',
        add:'เพิ่ม',
        list: 'รายชื่อ',
      },
      settings: {
        title: 'ตั้งค่า',
        category: 'หมวดหมู่',
        department: 'ตำแหน่ง',
        faq: 'คำถามที่พบบ่อย',
        assessment: 'การประเมิน',
        reset_user: 'รีเซ็ต ผู้ใช้งาน'
      },
      profile: {
        title: 'โปรไฟล์',
        edit: 'โปรไฟล์',
        changeLanguage: 'English',
        input:{
          email: 'อีเมล',
          username: 'ชื่อผู้ใช้',
          password: 'รหัสผ่านใหม่',
          position: 'ตำแหน่ง',
          department: 'แผนก',
          password_confirm: 'ยืนยันรหัสผ่าน',
          prefix: 'คำนำหน้า',
          first_name: 'ชื่อ',
          last_name: 'นามสกุล'
        }
      },
      report:{
        title: 'รายงาน',
        on: 'เปิด',
        off: 'ปิด',
        assessment: 'ผลการประเมิน',
        part: 'รอบการใช้งาน'
      },
      info:{
        profile: 'ข้อมูลส่วนตัว',
        fullname: 'ชื่อ-นามสกุล',
        email: 'อีเมล',
        department: 'ตำแหน่ง',
        lesson: 'บทเรียน',
        my_lesson: 'บทเรียนของฉัน',
        company: 'บริษัท'
      },
      table:{
        name: 'ชื่อ',
        fullname: 'ชื่อ-นามสกุล',
        email: 'อีเมล',
        username: 'ชื่อผู้ใช้',
        position: 'ระดับ',
        partner: 'พาร์ทเนอร์',
        department: 'ตำแหน่ง',
        category: 'หมวดหมู่',
        lesson: 'ชื่อบทเรียน',
        action: 'ฟังก์ชัน',
        employee: 'พนักงาน',
        name_th: 'ชื่อภาษาไทย',
        name_en: 'ชื่อภาษาอังกฤษ',
        type: 'ประเภท',
        point: 'คะแนน',
        amount: 'จำนวน'
      },
      button:{
        login: 'เข้าสู่ระบบ',
        save: 'บันทึก',
        cancel: 'ยกเลิก',
        add: 'เพิ่ม',
        lesson: 'เข้าสู่บทเรียน',
        create: 'สร้าง',
        update: 'อัพเดท'
      },
      header:{
        addPartner: 'เพิ่ม พาร์ทเนอร์',
      },
      placeholder:{
        type: 'ประเภท',
        email: 'อีเมล',
        username: 'ชื่อผู้ใช้งาน',
        password: 'รหัสผ่าน',
        partner: 'ชื่อพาร์ทเนอร์',
        position: 'ตำแหน่ง',
        department: 'ตำแหน่ง',
        prefix: 'คำนำหน้า',
        first_name: 'ชื่อ',
        last_name: 'นามสกุล',
        lesson: 'ชื่อบทเรียน',
        address: 'ที่อยู่',
        phone: 'เบอร์โทรศัพท์',
        level: 'เลือกระดับ'
      },
      input:{
        name_th: 'ชื่อภาษาไทย',
        name_en: 'ชื่อภาษาอังกฤษ'
      },
      select:{
        department: 'ตำแหน่ง',
        category: 'หมวดหมู่',
        lesson: 'เลือกบทเรียน',
        business: 'เลือกบริษัท',
        employee: 'เลือกพนักงาน',
        show: 'แสดง',
        hide: 'ซ่อน'
      },
      toast:{
        success: 'สำเร็จ',
        failed: 'ผิดพลาด'
      },
      search:{
        title: 'ค้นหา',
        employee: 'ค้นหาพนักงาน'
      },
      quiz:{
        question: 'คำถาม',
        answers: 'คำตอบ',
        answer_number: 'คำตอบที่',
      }
    }
  },
  en: {
    message: {
      auth:{
        signin: 'SignIn',
        signout: 'SignOut'
      },
      partner: {
        title: 'Partners',
        add:'Add',
        list: 'List'
      },
      lesson: {
        title: 'Lessons',
        add:'Add',
        list: 'List'
      },
      user: {
        title: 'Users',
        add:'Add',
        list: 'List'
      },
      settings: {
        title: 'Settings',
        category: 'Categories',
        department: 'Department',
        faq: 'FAQ',
        assessment: 'Assessment',
        reset_user: 'Reset user'
      },
      profile: {
        title: 'Profile',
        edit: 'Profile',
        changeLanguage: 'ไทย',
        input:{
          email: 'Email',
          username: 'Username',
          password: 'Password',
          position: 'Position',
          department: 'Department',
          password_confirm: 'Password Confirmation',
          prefix: 'Prefix',
          first_name: 'First Name',
          last_name: 'Last Name',
        }
      },
      report:{
        title: 'Report',
        on: 'ON',
        off: 'OFF',
        assessment: 'Assessment',
        part: 'Part'
      },
      info:{
        profile: 'Profile',
        fullname: 'Fullname',
        email: 'Email',
        department: 'Position',
        lesson: 'Lesson',
        my_lesson: 'My Lesson',
        company: 'Company'
      },
      table:{
        name: 'Name',
        fullname: 'Fullname',
        email: 'Email',
        username: 'Username',
        position: 'Position',
        partner: 'Partner',
        department: 'Department',
        category: 'Category',
        lesson: 'Lesson',
        action: 'Action',
        employee: 'Employee',
        name_th: 'Thai Name',
        name_en: 'English Name',
        type: 'type',
        point: 'Point',
        amount: 'Amount'
      },
      button:{
        login: 'Login',
        save: 'Save',
        cancel: 'Cancel',
        add: 'Add',
        lesson: 'Lesson',
        create: 'Create',
        update: 'Update'
      },
      header:{
        addPartner: 'Add Partner',
      },
      placeholder:{
        type: 'Type',
        email: 'Email',
        username: 'Username',
        password: 'Password',
        partner: 'Partner',
        position: 'Position',
        department: 'Department',
        first_name: 'First Name',
        last_name: 'Last Name',
        lesson: 'Lesson',
        address: 'Address',
        phone: 'Phone',
        level: 'Level'
      },
      input:{
        name_th: 'Thai Name',
        name_en: 'English Name'
      },
      select:{
        department: 'Position',
        category: 'Category',
        lesson: 'Choose Lesson',
        business: 'Choose Business',
        employee: 'Choose Employee',
        show: 'Show',
        hide: 'Hide'
      },
      toast:{
        success: 'Success',
        failed: 'Failed'
      },
      search:{
        title: 'Search',
        employee: 'Search Employee'
      },
      quiz:{
        question: 'Question',
        answers: 'Answers',
        answer_number: 'Answer Number',
      }
    }
  }
}
const i18n = createI18n({
  locale: localStorage.getItem('Lang') || 'th',
  fallbackLocale: 'en',
  messages,
})

app.use(store)
app.use(router)
app.use(PrimeVue, {
  theme: {
      preset: Aura,
      options: {
          prefix: 'p',
          darkModeSelector: 'system',
          cssLayer: false
      }
  }
});

app.use(i18n)
app.use(ToastService);
app.use(ConfirmationService)

app.directive('tooltip', Tooltip);
app.component('ToolBar', ToolBar);
app.component('Menubar', Menubar);
app.component('InputText', InputText);
app.component('Button', Button);
app.component('Image', Image);
app.component('Dropdown', Dropdown);
app.component('SelectButton', SelectButton);
app.component('DataTable', DataTable);
app.component('Editor', Editor);
app.component('FileUpload', FileUpload);
app.component('Paginator', Paginator);
app.component('Message', Message);
app.component('Dialog', Dialog);
app.component('Listbox', Listbox);
app.component('Checkbox', Checkbox);
app.component('RadioButton', RadioButton);
app.component('ProgressSpinner', ProgressSpinner);
app.component('ProgressBar', ProgressBar);
app.component('ScrollPanel', ScrollPanel)
app.component('Fieldset', Fieldset)
app.component('Dock', Dock)
app.component('Avatar', Avatar)
app.component('Ripple', Ripple)
app.component('Toast', Toast)
app.component('SplitButton', SplitButton)
app.component('SpeedDial', SpeedDial)
app.component('Chart', Chart)
app.component('ConfirmDialog', ConfirmDialog)
app.component('InputNumber', InputNumber)
app.component('PanelMenu', PanelMenu)
app.component('Accordion', Accordion)
app.component('AccordionTab', AccordionTab)
app.component('Textarea', Textarea)
app.component('CascadeSelect', CascadeSelect)
app.component('AutoComplete', AutoComplete)
app.component('ToggleSwitch', ToggleSwitch)
app.component('DatePicker', DatePicker)

app.component('RadialProgress', RadialProgress)

app.component('font-awesome-icon', FontAwesomeIcon)

app.mount('#app');